import { Injectable, ComponentRef, ApplicationRef, ComponentFactoryResolver, Injector } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export class AmazingTimePickerRef {
  private closeSubject = new Subject<string>();

  afterClose(): Observable<string> {
    return this.closeSubject.asObservable();
  }

  close(time?: string) {
    this.closeSubject.next(time || '');
    this.closeSubject.complete();
  }
}

@Injectable({ providedIn: 'root' })
export class AmazingTimePickerService {
  open(config?: any): AmazingTimePickerRef {
    const ref = new AmazingTimePickerRef();

    // Use browser's native time input via a prompt-style dialog
    setTimeout(() => {
      const container = document.createElement('div');
      container.style.cssText = `
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.5); z-index: 99999;
        display: flex; align-items: center; justify-content: center;
      `;

      const dialog = document.createElement('div');
      dialog.style.cssText = `
        background: white; border-radius: 8px; padding: 24px; min-width: 280px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.3); text-align: center;
      `;

      dialog.innerHTML = `
        <h4 style="margin-bottom: 16px; color: #333;">Select Time</h4>
        <input type="time" id="atp-time-input" value="12:00"
          style="font-size: 18px; padding: 8px 12px; border: 1px solid #ddd;
                 border-radius: 4px; width: 100%; margin-bottom: 16px;" />
        <div style="display: flex; gap: 10px; justify-content: center;">
          <button id="atp-cancel"
            style="padding: 8px 20px; border: 1px solid #ccc; border-radius: 4px;
                   background: white; cursor: pointer;">Cancel</button>
          <button id="atp-ok"
            style="padding: 8px 20px; border: none; border-radius: 4px;
                   background: #007bff; color: white; cursor: pointer;">OK</button>
        </div>
      `;

      container.appendChild(dialog);
      document.body.appendChild(container);

      const input = document.getElementById('atp-time-input') as HTMLInputElement;
      const okBtn = document.getElementById('atp-ok');
      const cancelBtn = document.getElementById('atp-cancel');

      const cleanup = () => document.body.removeChild(container);

      okBtn!.addEventListener('click', () => {
        const val = input.value; // "HH:MM"
        const [h, m] = val.split(':');
        const hour = parseInt(h);
        const min = m;
        const meridian = hour < 12 ? 'am' : 'pm';
        const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const formattedTime = `${displayHour}:${min} ${meridian}`;
        cleanup();
        ref.close(formattedTime);
      });

      cancelBtn!.addEventListener('click', () => {
        cleanup();
        ref.close('');
      });

      container.addEventListener('click', (e) => {
        if (e.target === container) {
          cleanup();
          ref.close('');
        }
      });
    }, 0);

    return ref;
  }
}
